export default __webpack_public_path__ + "static/media/Reward.0798e028.svg";